export default {
  alias               : 'regulations',
  route               : '/app/normatividad/regulations',
  hash                : false,
  store               : false,
  name                : 'reg_title',
  key                 : 'id',
  selectable          : true,
  maxRelationsResolve : 3,
  relations           : [
    {
      attribute : 'files_url',
      alias     : 'files_url',
      module    : 'regulation_file'
    },
    
    {
      attribute : 'files',
      alias     : 'files',
      module    : 'regulation_file'
    }
  ],
  default : {
    id                         : null,
    regulations_tipo           : null,
    regulations_tipos_sigla_id : null,
    reg_title                  : null,
    reg_ofic                   : null,
    reg_description            : null,
    reg_observation            : null,
    reg_date                   : null,
    reg_status                 : true,
    reg_year                   : true,
    files                      : [],
    reg_num                    : null,
    admin_idadmin              : null,
    reg_proyecto               : null,
    tab                        : 0,
    created_at                 : null,
    updated_at                 : null
  }
}
